// src/oura/lib/useDrawerChrome.ts
//
// The two behaviours every slide-over in this product needs and none of them
// had: the page behind stops scrolling, and Escape closes.
//
// Without the scroll lock the wheel falls through to the page underneath, so
// reaching the bottom of a drawer silently scrolls the tracker behind it and
// the drawer appears to jump when it closes. Without Escape the only way out is
// finding a small X, which on a full-height drawer can be off screen.
//
// Written once rather than per drawer because they were already drifting: one
// had a click-away overlay, the other a slightly different one, and neither
// locked anything.
//
// Escape goes through the shared escape stack rather than a listener of its
// own, so a lightbox opened inside a drawer closes before the drawer does.

import { useEffect } from "react";
import { useEscapeLayer } from "../ui/escapeLayer";

export function useDrawerChrome(open: boolean, onClose: () => void): void {
    useEscapeLayer(onClose, open);

    useEffect(() => {
        if (!open) return;

        // Compensate for the scrollbar the lock removes. Without this the page
        // jumps sideways as the drawer opens, which reads as a layout bug.
        const scrollbar = window.innerWidth - document.documentElement.clientWidth;
        const { overflow, paddingRight } = document.body.style;
        document.body.style.overflow = "hidden";
        if (scrollbar > 0) document.body.style.paddingRight = `${scrollbar}px`;

        return () => {
            document.body.style.overflow = overflow;
            document.body.style.paddingRight = paddingRight;
        };
    }, [open]);
}
